import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const breadcrumbNames = {
  szolgaltatasok: 'Szolgáltatások',
  'egyeni-sminktanacsadas': 'Egyéni Sminktanácsadás',
  rolam: 'Rólam',
  blog: 'Blog',
  munkak: 'Munkáim',
  kontakt: 'Kapcsolat',
  nonap: 'Nőnap 2026',
  divat: 'Divat',
  'alkalmi-sminkek': 'Alkalmi Sminkek',
  'eskuvoi-munkaim': 'Esküvői Munkáim',
  'tanuloim-munkai': 'Tanulóim Munkái',
};

const buildBreadcrumbs = (url, baseUrl) => {
  if (!url || url === '/') return null;
  const segments = url.split('/').filter(Boolean);
  const items = [{ '@type': 'ListItem', position: 1, name: 'Kezdőlap', item: baseUrl }];
  let path = '';
  segments.forEach((segment, index) => {
    path += `/${segment}`;
    items.push({
      '@type': 'ListItem',
      position: index + 2,
      name: breadcrumbNames[segment] || segment,
      item: `${baseUrl}${path}`,
    });
  });
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items,
  };
};

const SEO = ({ title, description, image, url }) => {
  const siteTitle = 'The Makeup Lab';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} — Sminkes Budapest, Önsminkelés és Alkalmi Smink`;
  const defaultDescription =
    'Professzionális sminkes szolgáltatások Budapesten, V. kerület (5. kerület), belváros. Alkalmi smink, esküvői smink, egyéni önsminkelés oktatás és sminktanácsadás.';
  const defaultImage = 'https://themakeuplab.hu/og-image.jpg';
  const baseUrl = 'https://themakeuplab.hu';

  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const metaUrl = url ? `${baseUrl}${url}` : baseUrl;
  const breadcrumbs = buildBreadcrumbs(url, baseUrl);

  return (
    <Helmet>
      <html lang="hu" />
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={metaUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={metaUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content="The Makeup Lab — sminkes Budapest" />
      <meta property="og:locale" content="hu_HU" />
      <meta property="og:site_name" content="The Makeup Lab" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
      <meta name="twitter:image:alt" content="The Makeup Lab — sminkes Budapest" />

      {/* BreadcrumbList Schema */}
      {breadcrumbs && <script type="application/ld+json">{JSON.stringify(breadcrumbs)}</script>}
    </Helmet>
  );
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  url: PropTypes.string,
};

export default SEO;
